import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-594025e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sa-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "sa-page-title" }, "Super-Administration", -1))
const _hoisted_3 = { class: "sa-subnav" }
const _hoisted_4 = { class: "sa-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "sa-title" }, "Kursverwaltung"),
  /*#__PURE__*/_createElementVNode("p", { class: "sa-subtitle" }, "Kurskatalog verwalten und Org-Sichtbarkeit steuern")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "sa-loading"
}
const _hoisted_7 = {
  key: 1,
  class: "sa-error"
}
const _hoisted_8 = {
  key: 2,
  class: "sa-card"
}
const _hoisted_9 = { class: "sa-table" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Titel"),
    /*#__PURE__*/_createElementVNode("th", null, "Kategorie"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Sichtbarkeit"),
    /*#__PURE__*/_createElementVNode("th", null, "Aktionen")
  ])
], -1))
const _hoisted_11 = { class: "sa-id" }
const _hoisted_12 = { class: "sa-course-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sa-provider" }, "SCORM", -1))
const _hoisted_14 = {
  key: 0,
  class: "sa-muted"
}
const _hoisted_15 = {
  key: 1,
  class: "sa-all"
}
const _hoisted_16 = {
  key: 2,
  class: "sa-restricted"
}
const _hoisted_17 = { class: "sa-actions" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "sa-empty"
}, "Noch keine Kurse vorhanden.", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "sa-modal" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Kurs löschen?", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "sa-modal-actions" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/superadmin/organisations",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Organisationen")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/courses",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Kurse")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/superadmin/instruction-library",
        class: "sa-subnav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Unterweisungen")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_router_link, {
        to: "/superadmin/courses/new",
        class: "btn btn-primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" + Neuer Kurs ")
        ]),
        _: 1
      })
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Kurse werden geladen …"))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.error), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: course.courseId
                  }, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(course.courseId), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(course.title), 1),
                      _hoisted_13
                    ]),
                    _createElementVNode("td", null, _toDisplayString(course.category), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['status-badge', course.published ? 'status-published' : 'status-draft'])
                      }, _toDisplayString(course.published ? 'Veröffentlicht' : 'Entwurf'), 3)
                    ]),
                    _createElementVNode("td", null, [
                      (!_ctx.visibilityMap[course.courseId])
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "—"))
                        : (_ctx.visibilityMap[course.courseId].includes('*'))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Alle Orgs "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.visibilityMap[course.courseId].length) + " Org(s) ", 1))
                    ]),
                    _createElementVNode("td", _hoisted_17, [
                      _createVNode(_component_router_link, {
                        to: `/superadmin/courses/${course.courseId}`,
                        class: "btn-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Bearbeiten ")
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("button", {
                        class: "btn-link btn-danger",
                        onClick: ($event: any) => (_ctx.confirmDelete(course))
                      }, " Löschen ", 8, _hoisted_18)
                    ])
                  ]))
                }), 128)),
                (_ctx.courses.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_19, _hoisted_21))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
    (_ctx.deleteTarget)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "sa-modal-backdrop",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.deleteTarget = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("p", null, [
              _createTextVNode("Möchten Sie den Kurs "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.deleteTarget.title), 1),
              _createTextVNode(" wirklich löschen?"),
              _hoisted_24,
              _createTextVNode(" Diese Aktion kann nicht rückgängig gemacht werden.")
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                class: "btn btn-secondary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteTarget = null))
              }, "Abbrechen"),
              _createElementVNode("button", {
                class: "btn btn-danger",
                disabled: _ctx.deleting,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.doDelete && _ctx.doDelete(...args)))
              }, _toDisplayString(_ctx.deleting ? 'Wird gelöscht …' : 'Löschen'), 9, _hoisted_26)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}